import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NotificationService } from "src/app/services/notification.service";
import { NotificationType } from "src/app/shared/models/Notification";
import { ToastService } from "../toast.service";

@Component({
   selector: "app-toast-notification",
   templateUrl: "./toast-notification.component.html",
   styleUrls: ["./toast-notification.component.scss"],
})
export class ToastNotificationComponent implements OnInit {
   @ViewChild("dangerTpl") private dangerTemplate: TemplateRef<any>;
   subscriptions;
   constructor(public toastService: ToastService, private notificationService: NotificationService, private ref: ChangeDetectorRef) {}

   ngOnInit(): void {
      this.subscriptions = this.notificationService.multiNotifications.subscribe(
         (res) => {
            switch (res.type) {
               case NotificationType.Peligro:
                  this.showDanger(res.title, res.title, res.message);
                  this.ref.detectChanges();
                  break;
               case NotificationType.Advertencia:
                  this.showWarning(res.title, res.title, res.message);
                  this.ref.detectChanges();
                  break;
               case NotificationType.Informacion:
                  this.showInfo(res.title, res.title, res.message);
                  this.ref.detectChanges();
                  break;

               default:
                  break;
            }
         },
         (error) => {
            console.log("ERROR!!", error);
         }
      );
   }

   showStandard(notifTitle: string, notifMessage: string) {
      this.toastService.show("Este es un mensaje estandar", notifTitle, notifMessage, "flaticon-warning icon-2x text-light", { classname: "bg-info text-light", delay: 7000 });
   }

   showSuccess(notifTitle: string, notifMessage: string) {
      this.toastService.show("Mensaje de Exito", notifTitle, notifMessage, "flaticon-warning icon-2x text-light align-top float-left", { classname: "bg-success text-light", delay: 7000 });
   }
   showWarning(title: string, notifTitle: string, notifMessage: string) {
      this.toastService.show(title, notifTitle, notifMessage, "flaticon-warning icon-2x text-light align-top float-left", { classname: "bg-warning text-light", delay: 7000 });
   }
   showInfo(title: string, notifTitle: string, notifMessage: string) {
      this.toastService.show(title, notifTitle, notifMessage, "flaticon-warning icon-2x text-light align-top float-left", { classname: "bg-primary text-light", delay: 7000 });
   }
   showDanger(dangerTpl: any, notifTitle: string, notifMessage: string) {
      this.toastService.show(dangerTpl, notifTitle, notifMessage, "flaticon-warning icon-2x text-light align-top float-left", { classname: "bg-danger text-light", delay: 7000 });
   }

   ngOnDestroy() {
      this.subscriptions.unsubscribe();
   }
}
